import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import ReactQuill from "react-quill";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { errorDialogOpen } from "../../redux/dialogs/dialogActions";
import {
  ArrowForward,
  DeleteForever,
  DeleteOutlineOutlined,
  CancelOutlined,
  Close,
  CheckBox,
} from "@mui/icons-material";
import { AddApplicationContext } from "../../context/AddApplicationContext";
import TestComponent from "../../components/TestComponent";
import ErrorModal from "../../components/ErrorModal";
import ErrorText from "../../components/ErrorText";
import { basePath } from "../../utility";
import ProcessProgress from "../../components/ProcessProgress";
import LoaderModal from "../../components/LoaderModal";
import PdfReader from "../../components/PdfReader";
import Dashboard from "../../pages/profiles/Dashboard";
import useFetch from "../../hooks/useFetch";
import { fontSize, width } from "@mui/system";
export default function Submission() {
  const url = basePath.url;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState(null);
  const [onSuccessButtonLable, setOnSuccessButtonLable] = useState(null);

  const [onErrorButtonLable, setOnErrorButtonLable] = useState(null);

  const [openPdf, setOpenPdf] = useState(false);
  const [paymentButtonCaption, setPaymentButtonCaption] = useState("submit");

  const [
    informationSourceList,
    isPendingInformationSource,
    errorInformationSource,
  ] = useFetch(`${url}demographics/information-source`);

  const navigate = useNavigate();
  const logger = useSelector((state) => {
    return state.logger;
  });

  const {
    currentStep,
    setStep,
    applicationId,
    setApplicationId,
    stepDetails,
    setStepDetails,
    stepsCompleteStatus,
    setStepsCompletedStatus,
  } = useContext(AddApplicationContext);

  const initialValues = {
    applicationFeeAmount: stepDetails.programApplicationFee
      ? stepDetails.programApplicationFee
      : 1000,
    paymentMode:
      stepDetails.submissionDetails && stepDetails.submissionDetails.paymentMode
        ? stepDetails.submissionDetails.paymentMode
        : "",
    transactionNumber:
      stepDetails.submissionDetails &&
      stepDetails.submissionDetails.transactionNumber
        ? stepDetails.submissionDetails.transactionNumber
        : "",
    termsAndConditions:
      stepDetails.submissionDetails &&
      stepDetails.submissionDetails.termsAndConditions
        ? stepDetails.submissionDetails.termsAndConditions
        : true,
    privacyPolicy:
      stepDetails.submissionDetails &&
      stepDetails.submissionDetails.privacyPolicy
        ? stepDetails.submissionDetails.privacyPolicy
        : true,
    informationSource:
      stepDetails.submissionDetails &&
      stepDetails.submissionDetails.informationSource
        ? stepDetails.submissionDetails.informationSource
        : "",
  };

  const validationSchema = Yup.object({
    applicationFeeAmount: Yup.string().required("Please enter amount"),
    paymentMode: Yup.string().required("Please select payment mode"),
    transactionNumber: Yup.string().when("paymentMode", {
      is: (val) => val == "mpesa",
      then: () => Yup.string().required("Please enter transaction number"),
    }),
    termsAndConditions: Yup.boolean()
      .required("The terms and conditions must be accepted.")
      .oneOf([true], "The terms and conditions must be accepted."),
    privacyPolicy: Yup.boolean()
      .required("The privacy policy must be accepted to proceed.")
      .oneOf([true], "The privacy policy must be accepted to proceed."),
    informationSource: Yup.string().required(
      "Please Select Information source"
    ),
  });

  const onSuccessCallback = () => {
    setOpenLoader(false);
    navigate("/");
  };

  const onErrorCallback = () => {
    setOpenLoader(false);
  };
  const onSubmitSubmission = async (values, onSubmitProps) => {
    setError(null);
    setLoading(true);
    setFeedback(null);
    setOpenLoader(true);
    setLoaderMessage("Submitting Payment");

    const applicationId = stepDetails.programDetails?.applicationId;
    const programApplicationNumber = stepDetails?.programApplicationNumber;
    const amount = stepDetails?.programApplicationFee;
    const modeOfPayment = values.paymentMode;
    const transactionNumber =
      values.paymentMode == "mpesa" ? values.transactionNumber : null;

    values.type = "add";

    try {
      const addProgram = await axios.post(`${url}application/verify-payment`, {
        applicationNumber: programApplicationNumber,
        transactionNumber: transactionNumber,
        modeOfPayment: modeOfPayment,
        paymentAmount: amount,
        applicationId: applicationId,
      });
      // console.log(addProgram);
      if (addProgram.data.message === "error") {
        let err_data = addProgram.data.data;
        setError(addProgram.data.data);
        setLoading(false);
        setFeedback(null);
        onSubmitProps.setSubmitting(false);
        // onSubmitProps.resetForm();
      } else {
        if (!addProgram.data.data) {
          setError(true);
          setOnErrorButtonLable("Ok");
          values.type === "add"
            ? setLoaderMessage(
                "Error Confirming Payment Details! Please try again"
              )
            : setLoaderMessage(
                "Error Updating Confirming Payment! Please try again"
              );
          setLoading(false);
        } else {
          const stepData = { ...stepDetails };
          stepData.paymentComplete = true;

          setStepDetails(stepData);
          setError(null);
          setLoading(false);
          setFeedback(
            "Payment Details Added Successfully, You will receive an email notification on approval of admission request. "
          );
          onSubmitProps.setSubmitting(false);
          onSubmitProps.resetForm();
          setOnSuccessButtonLable("Ok");
          // setStep1Completed(true);
          values.type === "add"
            ? setLoaderMessage(
                "Payment Details added successfully! You will receive an email confirming your admission status after approval! Please login after 24 hours to check your application status"
              )
            : setLoaderMessage(
                "Payment Details updated successfully! You will receive an email confirming your admission status after approval! Please login after 24 hours to check your application status"
              );
          setLoading(false);
          setError(null);
        }
      }
    } catch (error) {
      setLoaderMessage(`Error  Confirming Payment Details ${error.message}`);
      setError("Error  Confirming Payment Details");
      setOnErrorButtonLable("Ok");
      // addProgram.data.action === "add"
      //   ? setLoaderMessage("Error Adding Program Details! Please try again")
      //   : setLoaderMessage("Error Updating Program Details! Please try again");
      setLoading(false);
      setFeedback(null);
      onSubmitProps.setSubmitting(false);
      //onSubmitProps.resetForm();
    }
  };

  return (
    <>
      <Dialog
        open={openPdf}
        onClose={() => {
          setOpenPdf(false);
        }}
      >
        <DialogContent>
          <PdfReader path={""} />
        </DialogContent>
      </Dialog>
      <ErrorModal />
      <LoaderModal
        loaderMessage={loaderMessage}
        openLoader={openLoader}
        setOpenLoader={setOpenLoader}
        loading={loading}
        error={error}
        onSuccessButtonLable={onSuccessButtonLable}
        onSuccessCallback={onSuccessCallback}
        onErrorButtonLable={onErrorButtonLable}
        onErrorCallback={onErrorCallback}
      />
      <div className="addBookWrapper">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmitSubmission}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            isValid,
            isSubmitting,
            setFieldValue,
            setValues,
          }) => {
            return (
              <Form>
                <div className="addBookContainer">
                  <div className="addBookCaption">
                    <Typography variant="subtitle2">
                      <span className="header2">Information Source </span>
                    </Typography>
                  </div>
                  <div className="addBookDetails" style={{ marginBottom: 20 }}>
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        fontWeight: 500,
                        color: "#181717",
                      }}
                    >
                      Please select Information Source
                    </Typography>
                    <div className="formConrol" style={{ width: "100%" }}>
                      {/* <InputLabel id="edition-number">
                  Edition Number{" "}
                  <span style={{ color: "grey" }}>(optional)</span>
                </InputLabel> */}
                      <Field
                        as="select"
                        name="informationSource"
                        id="informationSource"
                      >
                        <option value="">Select Information Source</option>
                        {informationSourceList &&
                          informationSourceList.map((item, index) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                      </Field>

                      <div style={{ height: 10 }}>
                        <ErrorMessage
                          name="informationSource"
                          component={ErrorText}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="addBookDetails" style={{ marginBottom: 10 }}>
                    <div
                      className="formConrol"
                      style={{
                        width: "100%",
                        // backgroundColor: "yellow",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <div>
                        <Field
                          // type="text"
                          type={"checkbox"}
                          name="termsAndConditions"
                          id="termsAndConditions"
                          style={{
                            backgroundColor: "grey",
                            width: "45px",
                            height: "22px",
                          }}
                        />
                      </div>

                      <div>
                        <div
                          variant="subtitle2"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Typography
                            style={{
                              fontWeight: 500,
                              color: "#181717",
                              cursor: "pointer",
                              fontSize: 12,
                            }}
                          >
                            I have read and understood The East Afican
                            University
                          </Typography>
                          <Typography
                            color={"#2470f4"}
                            style={{ color: "2470f4" }}
                            onClick={() => {
                              setOpenPdf(true);
                            }}
                          >
                            Terms and Conditions
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div style={{ height: 10 }}>
                      <ErrorMessage
                        name="termsAndConditions"
                        component={ErrorText}
                      />
                    </div>
                  </div>
                  <div className="addBookDetails">
                    <div
                      className="formConrol"
                      style={{
                        width: "100%",
                        // backgroundColor: "yellow",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <div>
                        <Field
                          // type="text"
                          type={"checkbox"}
                          name="privacyPolicy"
                          id="privacyPolicy"
                          style={{
                            backgroundColor: "grey",
                            width: "45px",
                            height: "22px",
                          }}
                        />
                      </div>

                      <div>
                        <div
                          variant="subtitle2"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Typography
                            style={{
                              fontWeight: 500,
                              color: "#181717",
                              cursor: "pointer",
                              fontSize: 12,
                            }}
                          >
                            I have read and understood The East Afican
                            University
                          </Typography>
                          <Typography
                            color={"#2470f4"}
                            style={{ color: "2470f4" }}
                            onClick={() => {
                              setOpenPdf(true);
                            }}
                          >
                            Privacy Policy
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div style={{ height: 10 }}>
                      <ErrorMessage
                        name="privacyPolicy"
                        component={ErrorText}
                      />
                    </div>
                  </div>
                </div>
                <div className="addBookContainer">
                  <div className="addBookCaption">
                    <Typography variant="subtitle2">
                      <span className="header2">Payment Mode</span>
                    </Typography>
                  </div>
                  <div className="addBookDetails">
                    <Typography
                      variant="subtitle2"
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        fontWeight: 500,
                        color: "#181717",
                      }}
                    >
                      Please select payment mode
                    </Typography>
                    <div className="formConrol" style={{ width: "100%" }}>
                      <Field as="select" name="paymentMode" id="paymentMode">
                        <option value="">Select Payment Mode</option>
                        <option value="mpesa">Mobile Money (mpesa)</option>
                        <option value="bank">Bank (credit/debit card)</option>
                      </Field>
                      <div style={{ height: 10 }}>
                        <ErrorMessage
                          name="paymentMode"
                          component={ErrorText}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {values.paymentMode == "mpesa" && (
                  <div className="addBookContainer">
                    <div className="addBookCaption">
                      <Typography variant="subtitle2">
                        <span className="header2">
                          {" "}
                          Payment Option 1: M-Pesa
                        </span>
                      </Typography>
                    </div>
                    <div className="addBookDetails">
                      <Typography
                        variant="subtitle2"
                        style={{
                          paddingTop: 10,
                          paddingBottom: 10,
                          fontWeight: 500,
                          color: "#181717",
                        }}
                      >
                        Please use the Paybill number, Account Number and Amount
                        specified below to complete your M-Pesa payment.{" "}
                        <span style={{ color: "#333533" }}>
                          Please note you are supposed to pay your application
                          fee before you submit your application
                        </span>
                      </Typography>
                      <div className="formConrol" style={{ width: "100%" }}>
                        {/* <Field
                          type="text"
                          name="applicationFeeAmount"
                          id="applicationFeeAmount"
                        /> */}
                        {/* <div style={{ height: 10 }}>
                          <ErrorMessage
                            name="applicationFeeAmount"
                            component={ErrorText}
                          />
                        </div> */}
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 35,
                            // borderBottom: "1px solid #f0f0f0",
                            padding: 5,
                            flexWrap: "wrap",
                          }}
                          // className="highlight-row"
                        >
                          <div
                            style={{
                              minWidth: "8%",
                              color: "#011846",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              gap: 3,
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#333533",
                              }}
                            >
                              Paybill Number:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: 18 }}
                            >
                              174507
                            </Typography>
                          </div>
                          <div
                            style={{
                              minWidth: "8%",
                              color: "#011846",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",

                              gap: 3,
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#333533",
                              }}
                            >
                              Account Number:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: 18 }}
                            >
                              {stepDetails.programApplicationNumber
                                ? stepDetails.programApplicationNumber
                                : "APP-001"}
                            </Typography>
                          </div>
                          <div
                            style={{
                              minWidth: "8%",
                              color: "#011846",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              gap: 3,
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#333533",
                              }}
                            >
                              Amount:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: 18 }}
                            >
                              {stepDetails.programApplicationFee
                                ? stepDetails.programApplicationFee
                                : 1000}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {values.paymentMode == "mpesa" && (
                  <div className="addBookContainer">
                    <div className="addBookCaption">
                      <Typography variant="subtitle2">
                        <span className="header2">
                          {" "}
                          M-Pesa Transaction Number
                        </span>
                      </Typography>
                    </div>
                    <div className="addBookDetails">
                      <Typography
                        variant="subtitle2"
                        style={{
                          paddingTop: 10,
                          paddingBottom: 10,
                          fontWeight: 500,
                          color: "#181717",
                        }}
                      >
                        Please enter M-Pesa payment Transaction number from your
                        M-Pesa payment message and Click the{" "}
                        <span style={{ color: "black" }}>
                          {" "}
                          "Complete Transaction"
                        </span>{" "}
                        Button
                      </Typography>
                      <div className="formConrol" style={{ width: "100%" }}>
                        <Field
                          type="text"
                          name="transactionNumber"
                          id="transactionNumber"
                        />
                        <div style={{ height: 10 }}>
                          <ErrorMessage
                            name="transactionNumber"
                            component={ErrorText}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: 10,
                    marginLeft: 0,
                    paddingTop: 10,
                    marginRight: 0,
                  }}
                >
                  <button
                    type="submit"
                    className="btn-secondary"
                    onClick={() => {
                      setStep((val) => {
                        return val - 1;
                      });
                    }}
                  >
                    &lt; Back to Book Contact Details
                  </button>
                  <button
                    type="submit"
                    className="btn-primary"
                    disabled={!isValid || isSubmitting}
                  >
                    {values.paymentMode == "mpesa"
                      ? "Complete Transaction"
                      : "Proceed to Payment"}
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
}
